import { render, staticRenderFns } from "./WorkflowFormBuilderTemplateFields.vue?vue&type=template&id=addf2dfa&"
import script from "./WorkflowFormBuilderTemplateFields.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderTemplateFields.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormBuilderTemplateFields.vue?vue&type=style&index=0&id=addf2dfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports